// extracted by mini-css-extract-plugin
export default {"persons_list":"teamPageStaff_persons_list__qF3UK","team_container":"teamPageStaff_team_container__ofDpg"};